module.exports = __webpack_public_path__ + "img/hunhe.350b6c38.png";